import { render } from "./ScholarshipApproveModal.vue?vue&type=template&id=7876d7a9&ts=true"
import script from "./ScholarshipApproveModal.vue?vue&type=script&lang=ts"
export * from "./ScholarshipApproveModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__